import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Icon } from '@iconify/react';
import ContactForm from '../ContactForm';
import Section from '../Section';
import ContactInfoSection from '../Section/ContactInfoSection';
import { pageTitle } from '../../helpers/PageTitle';
import { BASE_URL } from "../../helpers/api";
import '../../sass/shortcode/ContactBanner.scss';

// Falls back to these if the /settings API call fails or hasn't
// resolved yet, so the banner never renders empty — same defaults
// the footer uses, since both read the same admin-configured row.
const DEFAULT_SETTINGS = {
  email: 'info@medayus.com',
  phone: '+91 9876543210',
  description: '45 Wellness Avenue, Andheri West, Mumbai 400058, India',
};

export default function Contact() {
  pageTitle('Contact');

  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    axios
      .get(`${BASE_URL}/settings`)
      .then((res) => {
        if (res.data && Object.keys(res.data).length) {
          setSettings((prev) => ({ ...prev, ...res.data }));
        }
      })
      .catch(() => {
        // keep DEFAULT_SETTINGS
      });
  }, []);

  return (
    <>
      <section className="cs_contact_banner">
        <span className="cs_contact_dots cs_contact_dots_1" />
        <span className="cs_contact_dots cs_contact_dots_2" />
        <span className="cs_contact_wave" />
        <div className="container">
          <div className="cs_contact_banner_row">
            <div className="cs_contact_banner_left">
              <span className="cs_contact_label">We're Here To Help</span>
              <h1>Contact Us</h1>
              <span className="cs_contact_underline" />
              <p>
                Reach out to us for the fastest response and care. Our team
                is always ready to assist you.
              </p>
              <div className="cs_contact_info_list">
                <div className="cs_contact_info_row">
                  <span className="cs_contact_info_icon">
                    <Icon icon="mdi:phone" />
                  </span>
                  <div className="cs_contact_info_body">
                    <strong>Phone</strong>
                    <span>{settings.phone}</span>
                  </div>
                </div>
                <div className="cs_contact_info_row">
                  <span className="cs_contact_info_icon">
                    <Icon icon="mdi:email-outline" />
                  </span>
                  <div className="cs_contact_info_body">
                    <strong>Email</strong>
                    <span>{settings.email}</span>
                  </div>
                </div>
                <div className="cs_contact_info_row">
                  <span className="cs_contact_info_icon">
                    <Icon icon="mdi:map-marker-outline" />
                  </span>
                  <div className="cs_contact_info_body">
                    <strong>Address</strong>
                    <span>{settings.description}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="cs_contact_banner_right">
              <div className="cs_contact_illustration">
                <span className="cs_contact_illustration_ring" />
                <div className="cs_contact_illustration_icons">
                  <Icon icon="mdi:phone-outline" className="cs_phone_icon" />
                  <Icon
                    icon="mdi:chat-outline"
                    className="cs_chat_icon"
                  />
                </div>
                <span className="cs_contact_illustration_badge">
                  <Icon icon="mdi:email-outline" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="container" style={{ marginTop: 60 }}>
        <div className="row">
          <div className="col-lg-10 offset-lg-1">
            <ContactForm />
          </div>
        </div>
      </div>
      <Section
        topMd={60}
        topLg={50}
        topXl={70}
        bottomMd={200}
        bottomLg={170}
        bottomXl={150}
      >
        { <ContactInfoSection sectionTitle="Find Us Here" /> }
      </Section>
    </>
  );
}
